module.exports = __webpack_public_path__ + "img/UsgsRedSymbol.bbfcd812.svg";